import dataCollection from './view/dataCollection.html'

export default {
  base: {
    state: 'declaration.vatDeclarationSurcharges.dataCollection',
    config: {
      url: '/dataCollection',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.vatDeclarationSurcharges.dataCollection.list',
      title: '申报数据采集',
    },
  },
  list: {
    state: 'declaration.vatDeclarationSurcharges.dataCollection.list',
    config: {
      url: '/list',
      template: dataCollection,
      controller: 'dataCollectionCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/dataCollection/routers.js